import React, {Component} from 'react'
import {request} from "../../helper/APIUtils";
import {hasUserRight, showAxiosError} from "../../helper/helper";
import NavBarKS from "../../components/NavBarKS";
import Table from "../../components/Table/Table";
import TextOverFlowTooltip from "../../components/TextOverFlowTooltip";
import {Modal, ModalBody, ModalHeader, Row, UncontrolledTooltip} from "reactstrap";
import UserForm from "./component/UserForm";
import Alert from "react-s-alert";
import SendMail from "./component/SendMail";
import {ACCESS_TOKEN, EntegratorConf} from "../../constants";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import SweetAlert from 'react-bootstrap-sweetalert';
import NotifyKS from "../../components/NotifyKS";
import StickButton from "../../components/StickButton";
import {EntegratorIdentifiers, UserRightsEnum} from "../../helper/enums";

class CollectiveUserList extends Component {

	constructor(props) {
		super(props);

		this.state = {
			selectedUser: null,
			customerVknTckn: null,
			aliasList: null,
			addUserModal: false,
			customerList: [{}],
			users: [],
			loading: false,
			searching: false,
			searchQuery: undefined,
			total: 0,
			page: 0,
			size: 10,
			manual: false,
			alert: null,
			notify: null
		};

		this.fetchCollectiveUserList = this.fetchCollectiveUserList.bind(this);
		this.cancelUserCreation = this.cancelUserCreation.bind(this);
		this.saveUser = this.saveUser.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
		this.handleCustomizeSidebar = this.handleCustomizeSidebar.bind(this);
		this.newMailSendRequestSuccess = this.newMailSendRequestSuccess.bind(this);
		this.checkRoleIdHandleSearch = this.checkRoleIdHandleSearch.bind(this);
	}

	handleCustomizeSidebar(item) {
		this.props.history.push({pathname:`/customizeSidebar/${item.recordId}`,source:'cUserList'});
	}


	fetchCollectiveUserList(accessor, direction, page, size) {
		let self = this;
		let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '&sort=recordId,desc';
		let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
		let params = {
			url: '/user/fetchCollectiveUsers?page=' + page + '&size=' + size + sortStr + searchQuery,
			method: "get",
		};
		self.setState({loading: true, manual: self.manual === true ? false : self.manual, searching: true});
		if (self.props.currentUser.roleId === 3 && (self.state.searchQuery === undefined || self.state.searchQuery === null)) {
			self.setState({loading: false, searching: false});
		} else {
			request(params)
				.then(function (response) {
					let users = response.data.content;
					self.setState({
						page: page,
						size: size,
						total: response.data.totalElements,
						users,
						loading: false,
						searching: false
					});
				}).catch(function (error) {
				self.setState({loading: false, searching: false});
				showAxiosError(error);
			});
		}
	}


	async getAliasListByCustomer(item) {
		let self = this;
		let params = {
			url: `/user/getAliasListByCustomer`,
			method: 'post',
			data: item.customer.vknTckn
		};
		let aliasList = null;
		await request(params).then(function (response) {
			aliasList = response.data;
			return aliasList;
		}).catch(function (error) {
			showAxiosError(error);
		});
		self.setState({aliasList})
	}

	async fetchUserByRecordId(item) {
		let self = this;
		let data = item.recordId;
		let params = {
			url: `/user/fetchUserByRecordId`,
			data: data,
			method: 'post'
		};
		let content = {};
		await request(params).then(function (response) {
			content.selectedUser = response.data.user;
			content.userBranchMap = response.data.branchMap;
			return content;
		}).catch(function (error) {
			showAxiosError(error);
		});
		self.setState({
			mode: 'edit',
			selectedUser: content.selectedUser,
			userBranchMap: content.userBranchMap,
			addUserModal: true,
			customerVknTckn: item.customer.vknTckn
		})
	}

	async handleEdit(item) {
		await this.getAliasListByCustomer(item);
		await this.fetchUserByRecordId(item);
		// this.setState({customerVknTckn: item.customerVknTckn});
	}

	saveUser(content) {
		let self = this;
		let data = content;

		let params = {
			url: `/user/createUser`,
			data: data,
			method: 'post'
		};
		request(params).then(() => {
			Alert.success('Kullanıcı başarıyla kaydedildi.', {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000,
				html:false
			});
			self.setState({
				addUserModal: false,
				branches: null,
				manual: true
			})
		}).catch(function (error) {
			showAxiosError(error);
		});
	}

	cancelUserCreation() {
		this.setState({
			addUserModal: false,
			selectedUser: null
		})
	}

	createUserForCustomer() {
		this.fetchCustomers();
		this.setState({
			addUserModal: true,
			mode: 'create'
		});
	}

	async fetchCustomers() {
		let self = this;
		let params = {
			url: `/customer/fetchByCreatedBy`,
			method: 'post'
		};
		let customers = [];
		await request(params).then(function (response) {
			if (response.data) {
				response.data.map(c => {
					let customer = {};
					customer.value = c.vknTckn;
					customer.label = c.vknTckn + ' , ' + c.formattedName;
					customer.recordId = c.recordId
					customers.push(customer);
				})
			}
			return customers;
		}).catch(function (error) {
			showAxiosError(error);
		});
		self.setState({customers})
	}

	impersonate(recordId) {
		if (recordId) {
			this.setState({disabledLoginBtn: true});
			let self = this;
			let params = {
				url: '/user/impersonate',
				method: "post",
				data: {
					recordId: recordId
				}
			};
			request(params)
				.then(function (response) {
					let data = response.data;
					localStorage.setItem(ACCESS_TOKEN, data.accessToken);
					self.props.onLogin();
					self.props.onImpersonate(true);
					self.setState({disabledLoginBtn: false});
				}).catch(function (error) {
				showAxiosError(error);
				self.setState({disabledLoginBtn: false});
			});
		} else {
			Alert.error("Kullanıcı seçimi yapmalısınız.", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 1500,
				html:false
			});
		}
	}

	handleSearch(searchQuery) {
		this.setState({
			searchQuery,
			searching: true
		}, () => this.fetchCollectiveUserList(this.state.accessor, this.state.direction, 0, this.state.size))
	}

	handleDelete(item) {
		let self = this;

		let params = {
			url: `/user/deleteCUser`,
			data: item,
			method: 'post'
		};

		let currentPage = this.state.page;

		const deleteUser = () =>

			request(params).then(function (response) {
				self.setState({
					notify: {
						type: 'success',
						message: 'Kullanıcı başarıyla silindi',
					},
					alert: null,
					manual: true,
					page: currentPage
				})
			}).catch(function (error) {
				self.setState({
					notify: {
						type: 'warning',
						message: 'Kullanıcı silme işlemi başarısız',
					},
					alert: null
				});
				showAxiosError(error);
			});


		this.setState({
			alert: (
				<SweetAlert showCancel warning
							disabled={this.state.loading}
							confirmBtnText="Evet"
							cancelBtnText="Hayır"
							confirmBtnBsStyle="danger"
							cancelBtnBsStyle="default"
							title="Emin misiniz?"
							onConfirm={() => {
								deleteUser(item)
							}}
							onCancel={() => this.setState({alert: null, notify: null})}>
					{item.username} kullanıcısı silinecek..! Onaylıyor musunuz ?
				</SweetAlert>
			)
		})
	}

	newMailSendRequestSuccess() {
		this.fetchCollectiveUserList(this.state.accessor, this.state.direction, this.state.page, this.state.size)
	}

	checkRoleIdHandleSearch(searchQuery) {
		let value = searchQuery.split("&")
		let result = {val:true, errorField: []}
		value.map((e) => {
			if (e.split("=")[0] === "username" && e.split("=")[1].length < 3) {
				result.val = false;
				result.errorField.push("Kullanıcı Adı ")
			}
			if (e.split("=")[0] === "customerId_formattedName" && e.split("=")[1].length < 3) {
				result.val =  false;
				result.errorField.push("Unvan ")
			}
			if (e.split("=")[0] === "firstName" && e.split("=")[1].length < 3) {
				result.val =  false;
				result.errorField.push("Ad ")
			}
			if (e.split("=")[0] === "lastName" && e.split("=")[1].length < 3) {
				result.val = false;
				result.errorField.push("Soyad ")
			}
			if ( e.split("=")[0] === "customerId_vknTckn" && e.split("=")[1].length < 3 ) {
				result.val = false;
				result.errorField.push("VKN/TCKN ")
			}
		})

		if (searchQuery === "") {
			result.val = false
		}

		if (result.val === true) {
			this.handleSearch(searchQuery)
		} else {
				if (result.errorField.length === 0) {
					let error = {response:{data: "Lütfen parametre giriniz!"}};
					showAxiosError(error)
				} else {
					let error = {response:{data: `${result.errorField} en az 3 karakter olmalıdır!`}};
					showAxiosError(error)
				}
		}
	}

	render() {
		const {users} = this.state;

		const columns = [
			{
				Header: "Kullanıcı Adı",
				accessor: "username"
			},
			{
				Header: "Adı",
				accessor: 'firstName',
                Cell: row => (row.firstName && <TextOverFlowTooltip text={row.firstName} maxLength={20}/>)
			},
			{
				Header: "Soyadı",
				accessor: "lastName",
                Cell: row => (row.lastName && <TextOverFlowTooltip text={row.lastName} maxLength={20}/>)
			},
			{
				Header: "Unvan",
				accessor: "customerId_formattedName",
				Cell: row => (<TextOverFlowTooltip text={row.customer && row.customer.formattedName} maxLength={20}/>)
			},
			{
				Header: "VKN/TCKN",
				accessor: "customerId_vknTckn",
				Cell: row => (<TextOverFlowTooltip text={row.customer && row.customer.vknTckn} maxLength={20}/>)
			},
			{
				Header: "Rol",
				accessor: "",
				sortable: false,
				Cell: row => (<label>{row.role && row.role.roleName}</label>)
			},
			{
				Header:<TextOverFlowTooltip text="e-Posta Gönderim Durumu" maxLength={8}/>,
				accessor: "",
				sortable: false,
				Cell:row =>(<div style={{margin: 0}}>
					{row.mailSent === 3 &&
					<button className="btn btn-icon btn-neutral btn-md" id={"mailSent4" + row.recordId}
							style={{backgroundColor: "inherit", color: "#dc3545", margin: 0}}>
						<i className="fa fa-envelope"></i>
					</button>
					}
					{row.mailSent === 3 &&
					<UncontrolledTooltip placement="right" target={"mailSent4" + row.recordId} delay={0}>
						{row.resultExplanation}
					</UncontrolledTooltip>
					}
					{row.mailSent === 0 && row.mailIsSending === 0 &&
					<button className="btn btn-icon btn-neutral btn-md" id={"mailSent0" + row.recordId}
							style={{backgroundColor: "inherit", color: "#FFB236", margin: 0}}>
						<i className="fa fa-envelope"></i>
					</button>
					}
					{row.mailSent === 0 && row.mailIsSending === 0 &&
					<UncontrolledTooltip placement="right" target={"mailSent0" + row.recordId} delay={0}>
						e-Posta gönderim bekliyor. {row.email ? "(" + row.email + ")" : ""}
					</UncontrolledTooltip>
					}
					{row.mailIsSending === 1 &&
					<button className="btn btn-icon btn-neutral btn-md" id={"mailSending0" + row.recordId}
							style={{backgroundColor: "inherit", color: "#e57f23", margin: 0}}>
						<i className="fa fa-envelope"></i>
					</button>
					}
					{row.mailIsSending === 1 &&
					<UncontrolledTooltip placement="right" target={"mailSending0" + row.recordId} delay={0}>
						e-Posta gönderiliyor. {row.email ? "(" + row.email + ")" : ""}
					</UncontrolledTooltip>
					}
					{row.mailSent === 1 &&
					<button className="btn btn-icon btn-neutral btn-md" id={"mailSent1" + row.recordId}
							style={{backgroundColor: "inherit", color: "#78d78f", margin: 0}}>
						<i className="fa fa-envelope"></i>
					</button>
					}
					{row.mailSent === 1 &&
					<UncontrolledTooltip placement="right" target={"mailSent1" + row.recordId} delay={0}>
						e-Posta gönderildi.{row.email ? "(" + row.email + ")" : ""}
					</UncontrolledTooltip>
					}
				</div>)
			},
			{
				Header: "",
				Cell: row => (
					<div>
						{(this.props.impersonateUserRoleId !== 3 && this.props.impersonateUserRoleId !== 4) && <button type="button" onClick={() => this.handleEdit(row)} rel="tooltip"
								 className="Btn btn-icon" title="Düzenle"
								 style={{background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}}>
							<i className="fa fa-edit"/>
						</button>}

						<SendMail item={row} currentUser={this.props.currentUser} newMailSendRequestSuccess={this.newMailSendRequestSuccess}/>

						{(row.customer.vknTckn === '9240517454' ? this.props.isAdmin : true) &&
							(this.props.allowPrivateAccess || (this.props.currentUser.roleId && (this.props.currentUser.roleId === 5 ||  this.props.currentUser.roleId === 3 || this.props.currentUser.roleId === 4))) &&
							this.props.impersonateUserRoleId !== 3 &&
							hasUserRight(UserRightsEnum.entegratorSettings.accessCustomerPortal, this.props.currentUser) &&
						<button type="button" onClick={() => this.impersonate(row.recordId)} rel="tooltip"
								className="Btn btn-icon" title="Kullanıcı Portalına Git"
								style={{background: 'rgb(52, 216, 103)'}}>
							<i className="fa fa-desktop"/>
						</button>}

						{(!this.props.currentUser.accountant || (this.props.currentUser.roleId && (this.props.currentUser.roleId === 5 || this.props.currentUser.roleId === 3 || this.props.currentUser.roleId === 4))) &&
						<button type="button"
								onClick={() => this.handleCustomizeSidebar(row)}
								data-toggle="tooltip" data-placement="bottom" title="Yan Menüyü Düzenle"
								style={{background: '#cdcf4e'}}
								rel="tooltip" className="Btn btn-sm btn-icon">
							<i className="fas fa-bars"></i>
						</button>}
					</div>
				)
			}
		];

		const fields = [
			{
				label: "Vkn/Tckn",
				accessor: "customerId_vknTckn",
				type: "numericText",
				operator: "="
			},
            {
                label: "Kullanıcı Adı",
                accessor: "username",
                type: "text",
                operator: "=",
            },
			{
				label: "Ad",
				accessor: "firstName",
				type: "text",
				operator: "=",
			},
			{
				label: "Soyad",
				accessor: "lastName",
				type: "text",
				operator: "=",
			},
			{
				label: "Unvan",
				accessor: "customerId_formattedName",
				type: "text",
				operator: "=",
			}
		];

		return (
			<div className="row baseBackground">

				{this.state.alert && this.state.alert}

				{(this.props.impersonateUserRoleId !== 3 && this.props.impersonateUserRoleId !== 4) &&
				<NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth}>
					<StickButton className='stickButton user-plus' position="leftSide"
								 onClick={() => this.createUserForCustomer()} label="Yeni Oluştur"/>
				</NavBarKS>}

				<div className="col-md-12 satirBasi">

					{this.state.notify &&
					<Row>
						<NotifyKS
							type={this.state.notify.type}
							message={this.state.notify.message}
							html={this.state.notify.html}
							timeout={this.state.notify.timeout}
							autohide={this.state.notify.autohide}
						/>
					</Row>}

					<div className="card-header ">
						<h4 className="card-title">Tüm Kullanıcılar</h4>
					</div>
					<div className="card-body">
						<div className=" ">
							<div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
								<DetailedSearch fields={fields}
												loading={this.state.searching}
												onSearch={(e) => {
													((EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier ||
															EntegratorIdentifiers.SMART === EntegratorConf.identifier ||
															EntegratorIdentifiers.MBT === EntegratorConf.identifier) && this.props.currentUser &&
														(this.props.currentUser.roleId === 3 || this.props.currentUser.roleId === 4)) ? this.checkRoleIdHandleSearch(e) : this.handleSearch(e)
												}}/>
							</div>
						</div>
					</div>
					<div className="card-body">
						<Table
							loading={this.state.loading}
							loadingText="Kayıtlar getiriliyor..."
							content={users}
							total={this.state.total}
							page={this.state.page}
							manual={this.state.manual}
							size={this.state.size}
							options={["5", "10", "20", "50", "100"]}
							columns={columns}
							fetchData={this.fetchCollectiveUserList}
							currentUser={this.props.currentUser}
						/>
					</div>
				</div>

				<Modal isOpen={this.state.addUserModal} size="lg" className="ust">
					<ModalHeader toggle={this.cancelUserCreation}>Kullanıcı Düzenle</ModalHeader>
					<ModalBody>
						<UserForm saveUser={this.saveUser} cancelProcess={this.cancelUserCreation} selectedUser={this.state.selectedUser} mode={this.state.mode}
								  branchMap={this.state.userBranchMap} aliasList={this.state.aliasList} customerVknTckn={this.state.customerVknTckn}
								  customers={this.state.customers} module={this.props.name}
								  currentUser={this.props.currentUser}/>
					</ModalBody>
				</Modal>

			</div>
		)
	}
}

export default CollectiveUserList;